import styled from 'styled-components';

import colors from '@/design/colors';
import ButtonExtra from '@/components/ButtonExtra';
import { dashedBorder } from '@/design/borders';

export const ButtonExtraContainer = styled(ButtonExtra)`
  height: 38px;
  background-image: none;
  border-radius: 4px;
  color: ${colors.blackAlpha100};

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: ${colors.purple100};

    ${dashedBorder({
      borderRadius: 4,
      dashArray: '10 10',
      lineCap: 'square',
      color: colors.purple100,
      strokeWidth: 2,
      sides: {
        top: true,
        right: false,
        bottom: false,
        left: false,
      },
    })}
  }
`;
